import React from 'react';
import PropTypes from 'prop-types';
import { ChangeHistory } from '@material-ui/icons';
// import {SvgIcon } from 'material-ui';

import chartCardStyle from '../assets/chardCardStyle';
import { withStyles, Card, CardContent, CardHeader, CardActions, Typography } from '@material-ui/core';

function ChartCard({ ...props }) {
  const {
    classes,
    chart,
    title,
    text,
    type,
  } = props;
  console.log(text)
  return (
    <Card className={classes.card}>
      {props.type !== 'spark' ? (
        <CardHeader
          classes={{
            root: classes.cardHeader,
            title: type === 'spark' ? classes.sparkCardTitle : classes.cardTitle,
          }}
          title={title}
        />
      ) : null}

      <CardHeader
        className={type === 'spark' ? 'sparkCardHeader' : 'cardHeader'}
        subheader={chart}
      />
      <CardContent className={type === 'spark' ? classes.sparkCardContent : classes.cardContent}>
        <Typography
          component="p"
          className={type === 'spark' ? classes.sparkCardCategory : classes.cardCategory}
        >
          {props.type === 'spark' ? (
            <Typography
              variant="title"
              component="h4"
              className={type === 'spark' ? classes.sparkCardTitle : classes.cardTitle}
            >
              {title}
            </Typography>
          ) : null}
          {text} {type === 'spark' ? ChangeHistory : null}
        </Typography>
      </CardContent>
      {props.type === 'spark' ? (
        <CardActions className={classes.cardActions}>
          {/* <div className={classes.cardStats}>
       <props.statIcon
         className={classes.cardStatsIcon + ' ' + classes[statIconColor + 'CardStatsIcon']}
       />{' '}
       {statLink !== undefined ? (
         <a href={statLink.href} className={classes.cardStatsLink}>
           {statLink.text}
         </a>
       ) : statText !== undefined ? (
         statText
       ) : null}
      </div>} */}
        </CardActions>
      ) : null}
    </Card>
  );
}

ChartCard.defaultProps = {
  statIconColor: 'gray',
  chartColor: 'purple',
};

ChartCard.propTypes = {
  classes: PropTypes.object.isRequired,
  chart: PropTypes.object.isRequired,
  title: PropTypes.node,
  text: PropTypes.node,
  statIcon: PropTypes.func,
  statIconColor: PropTypes.oneOf([
    'warning',
    'primary',
    'danger',
    'success',
    'info',
    'rose',
    'gray',
  ]),
  chartColor: PropTypes.oneOf(['orange', 'green', 'red', 'blue', 'purple', 'gray']),
  statLink: PropTypes.object,
  statText: PropTypes.node,
};
export default withStyles(chartCardStyle)(ChartCard);



// WEBPACK FOOTER //
// ./src/components/ChartCard.jsx